import { Component, Vue, Prop } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import TaskApi from '@/api/task'
let id: any = 0
import BillApi from '@/api/bill'
import VisitorApi from '@/api/visitor'
import { idCard } from '@/utils/validator'
import Moment from 'moment'
import { nameLength } from '@/config/global'

@Component({})
export default class AddTaskMixin extends Vue {
	public addForm: any = {}
	public addLoading: boolean = false
	public phoneId: number = 0
	public hasNoCarNo: boolean = false
	public isInjured: boolean = false
	public searchArea: any = []
	public noData: boolean = false
	public searchHospital: any = []
	public localSearch: any = ''
	public fetching: boolean = false
	public sameWithPublisher: boolean = false
	public areaName: string = ''
	public resurvey: boolean = false
	public endOpen: boolean = false
	public isPatient: any = true
	public taskType: any = ''
	public picId: any = ''
	public fileList: any = []
	public nameLength: any = nameLength

	public handleRemove() {
		this.fileList = []
	}

	public beforeUpload(e: any) {
		if (e.size > 2 * 1024 * 1024) {
			this.$message.error('文件大小不能超过2M')
			return false
		}
		const formData = new FormData()
		formData.append('filecontent', e)
		VisitorApi.operateAndUpload({
			formData,
			params: {
				cmd: 'imageMogr2/thumbnail/800x800',
			},
		}).then((res: any) => {
			this.fileList = [e]
			this.picId = res.data.picId
			this.$message.success('上传成功')
		})
		return false
	}

	public handleEndOpenChange(open: boolean) {
		this.endOpen = open
	}

	public disabledEndDate(endValue: any) {
		const startValue: any = this.addForm.getFieldValue('startIssueDate')
		const laterThanToday = endValue.valueOf() > Moment().endOf('day')
		if (!endValue || !startValue) {
			return laterThanToday
		}
		return startValue.valueOf() >= endValue.valueOf() || laterThanToday
	}

	public disabledStartDate(startValue: any) {
		const endValue: any = this.addForm.getFieldValue('endIssueDate')
		const laterThanToday = startValue.valueOf() > Moment().endOf('day')
		if (!startValue || !endValue) {
			return laterThanToday
		}
		return startValue.valueOf() > endValue.valueOf() || laterThanToday
	}

	public handleStartOpenChange(open: boolean) {
		if (!open) {
			this.endOpen = true
		}
	}

	public onPatientInput() {
		if (this.isPatient) {
			this.addForm.setFieldsValue({
				certigier: this.addForm.getFieldValue('injuredName'),
				certigierPhone: this.addForm.getFieldValue('injuredPhone'),
			})
		}
	}

	public onIsPatient() {
		this.isPatient = !this.isPatient
		if (this.isPatient) {
			this.addForm.setFieldsValue({
				certigier: this.addForm.getFieldValue('injuredName'),
				certigierPhone: this.addForm.getFieldValue('injuredPhone'),
			})
		}
	}

	public checkIdNo(rule: string, value: string, cb: any) {
		const idNo = value

		if (!idNo) {
			cb(new Error('请输入就诊人身份证号码'))
		} else if (!idCard(idNo)) {
			cb(new Error('请输入正确的身份证号码'))
		} else {
			cb()
		}
	}

	public created() {
		this.addForm = this.$form.createForm(this)
	}

	public onOk(orderId: any) {
		this.isPatient = false
		this.fileList = []
		this.addForm.resetFields()
		this.$multiTab.closeCurrentPage()
		this.$multiTab.open(`/bill/taskDetail/${orderId}`)
	}

	public onTaskAdd(e: any) {
		e.preventDefault()
		this.addForm.validateFields((err: any, values: any) => {
			if (!err) {
				if (!this.fileList.length) {
					return this.$message.error('请上传授权文件')
				}

				values = cloneDeep(values)
				values.startIssueDate =
					values.startIssueDate && values.startIssueDate.format('YYYY-MM-DD')
				values.endIssueDate =
					values.endIssueDate && values.endIssueDate.format('YYYY-MM-DD')
				values.taskType = this.taskType
				values.authorizeInfoId = this.picId

				this.addLoading = true
				BillApi.addBill(values)
					.then((data: any) => {
						this.$message.success(data.message || '发布成功')
						this.onOk(data.data.id)
					})
					.finally(() => {
						this.addLoading = false
					})
			}
		})
	}
}
